export default __webpack_public_path__ + "static/media/pathway_inactive.a63e68b3.svg";